import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'src/ui/library/styled';
import classNames from 'classnames';
import Grid from 'src/ui/library/Grid/Grid';
import quoteFailed from 'src/assets/quote-failed-graphic.svg';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import intl from 'react-intl-universal';

const styles = theme => ({
  hasError: {
    border: `solid 1px ${theme.colors.red}`,
  },
});

class DropdownBase extends Component {
  static propTypes = {
    /** if true, quote will be shown with red border */
    hasError: PropTypes.bool,
  };
  static defaultProps = {
    hasError: false,
  };

  render() {
    const { hasError, classes, className } = this.props;
    const rootClass = classNames({ [classes.hasError]: hasError }, className);

    return (
      <Grid container className={`quote-parent-div ${rootClass}`}>
        {this.props.helpText && <InfoTooltip toolTipText={this.props.helpText} className="quote-info" />}
        <Grid item xs={12} sm={6} md={6} lg={6} className="quote-wrapper">
          <div className="quote-failed">
            <img alt="quote-failed" src={quoteFailed} />
            <span className="quote-fail-label-1">{intl.get('default.label.tryAgain')}</span>
            <div className="quote-fail-label-2"> {intl.get('default.label.later')}</div>
          </div>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} className="quote-label-wrapper">
          <div className="quote-label">{intl.get('quoteFailed.message')}</div>
        </Grid>
        <Grid item xs={12} sm={3} md={3} lg={3} className="quote-label-wrapper-1">
          <div className="quote-label-1">{intl.get('quoteFailed.review')}</div>
        </Grid>
      </Grid>
    );
  }
}
export { DropdownBase };
export default styled(DropdownBase)(styles);
